const cookieMutators = (document) => {
  const addCookie = (cookie) => {
    if (!document) {
      return false;
    }
    if (!document["x-scalar-client-config-cookies"]) {
      document["x-scalar-client-config-cookies"] = {};
    }
    if (document["x-scalar-client-config-cookies"][cookie.name]) {
      console.warn(`Cookie with name "${cookie.name}" already exists in the document.`);
      return false;
    }
    document["x-scalar-client-config-cookies"][cookie.name] = cookie;
    return true;
  };
  const deleteCookie = (cookieName) => {
    if (!document || !document["x-scalar-client-config-cookies"]) {
      return false;
    }
    delete document["x-scalar-client-config-cookies"][cookieName];
    return true;
  };
  return {
    addCookie,
    deleteCookie
  };
};
export {
  cookieMutators
};
//# sourceMappingURL=cookie.js.map
